import { ILoginPayload } from "../redux/user/user.actions";
import {
    ICreateQuizPayload,
    IUpdateQuizPayload,
} from "../redux/quiz/quiz.actions";
import { IInsertQuestionPayload } from "../redux/question/question.actions";
import Feedback from "../@types/feedback.interface";

export function isEmpty(value: string) {
    return value.length === 0 || value === "" ? false : true;
}

export function validateLogin(data: ILoginPayload["data"], errors: any) {
    if (!isEmpty(data.username) || !isEmpty(data.password))
        return "Username and Password must be filled";
    if (errors?.includes("timeout")) return "Request Timeout";
    if (errors?.includes("Too Many Attempts.")) return "Too Many Request";
    else if (errors) return "Invalid Username or Password";
    return "Invalid Username or Password";
}

export function validateQuizForm(
    data: ICreateQuizPayload["data"] | IUpdateQuizPayload["data"],
    errors: any
) {
    if (data.user_id === 0) return "Invalid User !";
    if (data.course_id <= 0) return "Course must be selected";
    if (data.quiz_duration <= 0) return "Quiz Duration must be filled";
    return "";
}

function convert(num: number) {
    return String.fromCharCode(num + 65);
}

export function validateInsertQuestion(
    data: IInsertQuestionPayload["data"],
    errors: any
) {
    if (!isEmpty(data.question_quiz)) return "Question must be filled";
    for (let index = 0; index < data.question_choice.length; index++)
        if (!isEmpty(data.question_choice[index].answer))
            return `Answer for ${convert(index)} must be filled`;
    if (data.question_type_id < 1 || data.question_type_id > 2)
        return "Qustion Type must be selected";
    if (data.question_answer.length === 0)
        return "Question Answer must be Selected";
    if (data.question_answer[0].key === "")
        return "Question Answer must be Selected";
    if (data.question_type_id === 1)
        if (data.question_answer.length < 1 || data.question_answer.length > 1)
            return "The Answer to the Question must be one because the Question Type has a Single Answer";
    if (data.question_type_id === 2)
        if (data.question_answer.length < 2)
            return "The Answer to the Question must more than two because the Question Type has a Multiple Answer";
    if (data.weight_score === 0) return "Question Score must be filled";
    return "";
}

export function isBinusEmail(username: string) {
    if (
        username.endsWith("binus.ac.id") === true ||
        username.endsWith("binus.edu") === true
    ) {
        return true;
    }
    return false;
}

export function validateFeedback(data: Feedback) {
    if (data.feedback_email === "") return "Invalid User";
    else if (data.feedback_name === "") return "Name must be filled";
    else if (data.feedback_description === "")
        return "Feedback Description must be filled";
    return "";
}
